import { Form, Input } from "antd";
import { ColorPicker } from "components/UI";
import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";

const FormTag = forwardRef(({ onSubmit, data = {} }, ref) => {
  const { t } = useTranslation();
  const inputNameRef = useRef(null);
  const [form] = Form.useForm();

  const initialValues = useMemo(() => {
    return {
      name: data?.name || "",
      color: data?.color,
    };
  }, [data?.color, data?.name]);

  const submitHandler = useCallback(() => {
    form.submit();
  }, [form]);

  const getValueFromEventColorPicker = useCallback((e) => e.toHexString(), []);

  const inputNameFocus = useCallback(() => inputNameRef.current?.focus(), []);

  useImperativeHandle(
    ref,
    () => {
      return {
        onSubmit: submitHandler,
        onNameFocus: inputNameFocus,
      };
    },
    [inputNameFocus, submitHandler]
  );

  return (
    <Form
      layout="vertical"
      initialValues={initialValues}
      form={form}
      name="createTag"
      onFinish={onSubmit}
    >
      <Form.Item
        name="name"
        label={t("name")}
        rules={[
          {
            required: true,
            message: t("please_input_the_name"),
          },
          {
            max: 225,
            message: t("max_characters", { value: 225 }),
          },
          {
            min: 2,
            message: t("min_characters", { value: 2 }),
          },
        ]}
      >
        <Input placeholder={t("tag_name")} ref={inputNameRef} />
      </Form.Item>
      <Form.Item
        getValueFromEvent={getValueFromEventColorPicker}
        name="color"
        label={t("select_color")}
      >
        <ColorPicker showText allowClear />
      </Form.Item>
    </Form>
  );
});

FormTag.displayName = "FormTag";

export default FormTag;
